import React, { FC, useState } from 'react';
import FormikValidationError from '../FormikErrors';

interface ITextInput
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  containerClassName?: string;
  label: string;
  formik?: any;
  required?: boolean;
  disableRequiredValidation?: boolean;
  showPasswordToggle?: boolean;
}
const TextInput: FC<ITextInput> = (props) => {
  const { showPasswordToggle, ...inputProps } = props;
  const [showPassword, setShowPassword] = useState(false);
  const isTogglablePassword = showPasswordToggle && props.type === 'password';

  return (
    <div className={props.containerClassName ?? 'mt-3 col-lg-4 col-md-6 mb-2'}>
      <label htmlFor="fname-field" className="form-label" style={{ textTransform: 'capitalize' }}>
        {props.label}
        {props.required && <span>*</span>}
      </label>
      {isTogglablePassword ? (
        <div className="position-relative auth-pass-inputgroup">
          <input
            {...inputProps}
            type={showPassword ? 'text' : 'password'}
            className="form-control pe-5"
            required={props.disableRequiredValidation ? false : true}
          />
          <button
            aria-label={showPassword ? 'hide password' : 'show password'}
            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}>
            <i className={`${showPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'} align-middle`} />
          </button>
        </div>
      ) : (
        <input
          {...inputProps}
          className="form-control"
          required={props.disableRequiredValidation ? false : true}
        />
      )}
      <FormikValidationError
        name={props.name ?? ''}
        errors={props.formik.errors}
        touched={props.formik.touched}
      />
    </div>
  );
};

export default TextInput;
